import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d8087af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs" }

import { PropType, reactive, watch } from "vue";
import CustomTab from "../generics/CustomTab.vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderTabs',
  props: {
  tabs: {
    type: Array as PropType<{ linkText: string; linkTo: string }[]>,
    default: () => [
      { linkText: "Interrailkort", linkTo: "interrailkort" },
      { linkText: "Guider", linkTo: "guider" },
      { linkText: "Support", linkTo: "support" },
    ],
  },
},
  setup(__props) {

const props = __props;



const state = reactive({
  current_selected: "",
  current_hovered: "",
});

const route = useRoute();

function handle_hover(tab_name: string | null) {
  if (tab_name == null) {
    state.current_hovered = "";
    return;
  }
  state.current_hovered = tab_name;
}

watch(
  () => route.params,
  () => {
    var current_link_active_obj = props.tabs.find((tab_obj) => {
      return tab_obj.linkTo == route.path;
    });

    state.current_selected = current_link_active_obj
      ? current_link_active_obj?.linkText
      : "";
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, index) => {
      return (_openBlock(), _createBlock(CustomTab, {
        key: `tab-${index}`,
        selected: state.current_selected == tab.linkText,
        text: tab.linkText,
        fade: 
        state.current_hovered != '' && state.current_hovered != tab.linkText
      ,
        "link-to": tab.linkTo,
        onHover: handle_hover
      }, null, 8, ["selected", "text", "fade", "link-to"]))
    }), 128))
  ]))
}
}

})